import React from 'react'

import { MintButton } from '../../styles/PageLayout'

const BtnMintFive = ({ className, ...props }) => (
  <MintButton
    width="43"
    height="45"
    viewBox="0 0 43 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <rect
      x="42.5"
      y="44.5"
      width="42"
      height="44"
      transform="rotate(-180 42.5 44.5)"
      fill="white"
      stroke="#591ED8"
    />
    <path
      d="M17.2236 33.2266L17.2236 29.944L16.2718 29.944L16.2718 35.415L17.2236 35.415L17.2236 33.2266Z"
      fill="#591ED8"
    />
    <path
      d="M18.1758 28.8739L18.1758 27.8035L17.224 27.8035L17.224 29.9443L18.1758 29.9443L18.1758 28.8739Z"
      fill="#591ED8"
    />
    <path
      d="M16.2125 26.8512L13.1784 26.8512L13.1784 27.8027L17.2236 27.8027L17.2236 26.8512L16.2125 26.8512Z"
      fill="#591ED8"
    />
    <path
      d="M13.1787 25.7814L13.1787 24.7107L11.9889 24.7107L11.9889 26.8516L13.1787 26.8516L13.1787 25.7814Z"
      fill="#591ED8"
    />
    <path
      d="M13.1787 21.3806L11.9889 21.3806L11.9889 23.5215L13.1787 23.5215L13.1787 21.3806Z"
      fill="#591ED8"
    />
    <path
      d="M17.1636 14.958L23.4102 14.958L23.4102 13.7686L15.0817 13.7686L15.0817 14.958L17.1636 14.958Z"
      fill="#591ED8"
    />
    <path
      d="M24.4819 15.9092L25.5527 15.9092L25.5527 14.9577L23.4111 14.9577L23.4111 15.9092L24.4819 15.9092Z"
      fill="#591ED8"
    />
    <path
      d="M26.5833 17.0036L27.6146 17.0036L27.6146 25.7576L25.5521 25.7576L25.5521 26.8516L28.6455 26.8516L28.6455 15.9094L25.5521 15.9094L25.5521 17.0036L26.5833 17.0036Z"
      fill="#591ED8"
    />
    <path
      d="M16.1533 18.0508L18.1758 18.0508L18.1758 17.02L15.1419 17.02L15.1419 14.9584L14.1305 14.9584L14.1305 18.0508L16.1533 18.0508Z"
      fill="#591ED8"
    />
    <path
      d="M15.2012 21.3809L17.2236 21.3809L17.2236 20.2708L14.1898 20.2708L14.1898 18.0506L13.1784 18.0506L13.1784 21.3809L15.2012 21.3809Z"
      fill="#591ED8"
    />
    <path
      d="M15.2403 24.7109L16.2715 24.7109L16.2715 23.5216L13.1781 23.5216L13.1781 24.7109L15.2403 24.7109Z"
      fill="#591ED8"
    />
    <path
      d="M19.3656 34.3446L19.3656 35.415L20.3174 35.415L20.3174 33.2742L19.3656 33.2742L19.3656 34.3446Z"
      fill="#591ED8"
    />
    <path
      d="M20.3177 32.204L20.3177 33.2744L21.2695 33.2744L21.2695 31.1336L20.3177 31.1336L20.3177 32.204Z"
      fill="#591ED8"
    />
    <path
      d="M21.2692 30.0634L21.2692 31.1338L22.459 31.1338L22.459 28.9929L21.2692 28.9929L21.2692 30.0634Z"
      fill="#591ED8"
    />
    <path
      d="M22.4583 28.9922L23.4102 28.9922L23.4102 27.8028L22.4583 27.8028L22.4583 28.9922Z"
      fill="#591ED8"
    />
    <path
      d="M23.4111 26.8512L23.4111 27.8027L25.5527 27.8027L25.5527 26.8512L23.4111 26.8512Z"
      fill="#591ED8"
    />
    <path
      d="M30.6688 16.028L31.6801 16.028L31.6801 26.7323L28.6462 26.7323L28.6462 27.8027L32.6914 27.8027L32.6914 14.9576L28.6462 14.9576L28.6462 16.028L30.6688 16.028Z"
      fill="#591ED8"
    />
    <path
      d="M17.2236 35.4151L17.2236 36.6045L19.3652 36.6045L19.3652 35.4151L17.2236 35.4151Z"
      fill="#591ED8"
    />
  </MintButton>
)

export default BtnMintFive
